module.exports = __webpack_public_path__ + "img/review-photo.71a5798c.png";